import { environment } from '@/config/environment'
import { fetchAccessToken } from '@/api/AuthConfig'
import { Sensor } from '@/features/dashboard/models'
import { CreateEchoViewRequest, EchoTagInput, EchoViewResult } from '@/api/models/echo'

export async function createEchoViewForSensors(sensors: Sensor[]): Promise<string> {
    const tagged: EchoTagInput[] = sensors
        .filter((s): s is Sensor & { tag: string; plant: string } => Boolean(s.tag && s.plant))
        .map((s) => ({ plant: s.plant, tag: s.tag }))

    if (tagged.length === 0) {
        throw new Error('No sensors with both tag and plant available to send to Echo.')
    }

    const body: CreateEchoViewRequest = { sensors: tagged }

    const token = await fetchAccessToken(environment.BACKEND_API_SCOPE)

    const response = await fetch(`${environment.BACKEND_URL}/Echo/Views`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    })

    if (!response.ok) {
        const text = await response.text().catch(() => '')
        throw new Error(`Failed to create Echo view (${response.status}): ${text}`)
    }

    const data = (await response.json()) as EchoViewResult
    return data.viewUrl
}
